import { type ReactElement } from 'react';
import { Button } from '@fastnorth/kraken/components/button';
import { useMutation } from '@apollo/client';
import { SEND_NOTIFICATION } from './graphql/sendPushNotification';
import useServiceWorker from '../../lib/pwa/hooks/useServiceWorker';
import { Div } from '@fastnorth/kraken/components/layout';
import handleNotificationPermission from '../../lib/pwa/handleNotificationPermission';
import localStore from '../../lib/storage/localStore';

const PushNotificationsTest = (): ReactElement => {
  const [sendNotification] = useMutation(SEND_NOTIFICATION);
  const serviceWorker = useServiceWorker();
  const handleSavePushNotificationSubscriptionClick = async (): Promise<void> => {
    await sendNotification({
      variables: {
        id: 'not-really-needed-but-I-dont-know-how-to-write-this-query-without-params',
        body: {},
      },
      context: {
        // TODO update the line below to use localStore (which uses localforage) instead
        clientUuid: await localStore.getItem('rr-results-v3/user-locale'),
      },
    });
  };

  return (
    <Div spacing={'5 5'}>
      <Button onClick={handleNotificationPermission}>Authorize for push notifications</Button>
      <Button
        onClick={() =>
          serviceWorker?.showNotification('test', { body: 'Client side notification test' })
        }>
        test (client)
      </Button>
      <Button onClick={handleSavePushNotificationSubscriptionClick}>test (server)</Button>
    </Div>
  );
};

export default PushNotificationsTest;
